export const isWebView = (): boolean =>
  typeof window !== 'undefined' &&
  !!(window as Window & { ReactNativeWebView?: unknown }).ReactNativeWebView

export const isIframe = (): boolean =>
  typeof window !== 'undefined' && window.self !== window.top

const EMBED_SHELL_KEY = 'qsc.embedShell'
let currentShellMode: string | null = null

function readShellMode(): string | null {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  const shell = params.get('shell')
  if (shell) {
    currentShellMode = shell
    try {
      window.sessionStorage.setItem(EMBED_SHELL_KEY, shell)
    } catch {
      // Embedded storage can be unavailable; the current URL still wins.
    }
    return shell
  }

  try {
    return window.sessionStorage.getItem(EMBED_SHELL_KEY) ?? currentShellMode
  } catch {
    return currentShellMode
  }
}

export const isEmbeddedAppShell = (): boolean => isWebView() && readShellMode() === 'app'

export const usesHostSession = (): boolean => {
  if (typeof window === 'undefined') return false
  const params = new URLSearchParams(window.location.search)
  return isWebView() || isIframe() || params.get('embed') === '1'
}

// The host supplies authentication and native services; the web owns its UI.
export const isHostedWebShell = (): boolean => isWebView() && readShellMode() === 'web'

export const hasHostShell = (): boolean => usesHostSession() && !isEmbeddedAppShell()

export const isEmbedded = hasHostShell

export const showEmbedChrome = (): boolean => {
  if (typeof window === 'undefined') return false
  const params = new URLSearchParams(window.location.search)
  return hasHostShell() && params.get('embedChrome') === '1'
}
